module.exports = __webpack_public_path__ + "static/media/lightyear.29d1a4ad.png";